import{useContext as t}from"react";import o from"../context/StoreConfigContext.js";var r=function(){return t(o)};export{r as default};
